import ReactGA from 'react-ga4';

class GoogleAnalyticsService {
  private isInitialized = false;

  public initialize(trackingId?: string, enabled = false): void {
    if (enabled && trackingId && !this.isInitialized) {
      try {
        ReactGA.initialize(trackingId);
        this.isInitialized = true;
      } catch (error) {
        console.error('Failed to initialize Google Analytics:', error);
      }
    }
  }

  public trackPageView(path: string, title?: string): void {
    if (this.isInitialized) {
      try {
        ReactGA.send({ hitType: 'pageview', page: path, title: title });
      } catch (error) {
        console.error('Failed to track page view:', error);
      }
    }
  }

  public trackEvent(action: string, category: string, label?: string, value?: number): void {
    if (this.isInitialized) {
      try {
        ReactGA.event({
          action: action,
          category: category,
          label: label,
          value: value
        });
      } catch (error) {
        console.error('Failed to track event:', error);
      }
    }
  }

  public isEnabled(): boolean {
    return this.isInitialized;
  }
}

export const googleAnalytics = new GoogleAnalyticsService();
export default googleAnalytics;
